import React, { useState } from 'react';
import PriceOverrideDatatable from 'src/common/components/orderDetails/detailsDataTable/priceOverrideDataTable/PriceOverrideDataTable';
import NonBilledDataTable from 'src/common/components/orderDetails/detailsDataTable/nonBilledDatatable/NonBilledDatatable';
import PriceOverrideContainer from 'src/pages/orders/components/orderDetails/priceOverride/priceOverrideDetails/priceOverrideContainer/PriceOverrideContainer';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
const PriceOverrideDetailsListView = ({
    tissue,
    nonTissue,
    totalTissuePrice,
    totalNonTissuePrice,
    handleSetItemClick,
    ordersList,
    nonBilledList,
    orderType,
    total,
}) => {
    const { t } = useTranslation();
    const [tissueRowExpand, setTissueRowExpand] = useState(null);
    const [nonTissueRowExpand, setNonTissueRowExpand] = useState(null);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const updateRowExpandHandler = (updatedRowExpand, name) => {
        if (name === 'nonTissue') {
            setNonTissueRowExpand(updatedRowExpand);
        } else {
            setTissueRowExpand(tissueRowExpand);
        }
    };

    // const { orderBasicDetails } = useSelector(
    //     (state) => state.orderSummaryReducer
    // );
    // console.log('Ordertype in pricelist',orderBasicDetails);
    // const { orderType } = orderBasicDetails?.currentOrderType;
    // console.log('Ordertype in pricelist',orderType);
    const checkTissueBundle =
        tissue?.filter((x) => x.isBundleHeader)?.length > 0 ? true : false;

    const checkNonTissueBundle =
        nonTissue?.filter((x) => x.isBundleHeader)?.length > 0 ? true : false;

    return (
        <>
            {nonTissue && nonTissue?.length > 0 ? (
                <>
                    <PriceOverrideContainer
                        title={
                            countryISOCode == 'US'
                                ? t('orders.orderTypes.nonTissue')
                                : t(
                                      'orders.shipTrackLabels.productItemDescriptionLabel'
                                  )
                        }
                        price={totalNonTissuePrice}
                        total={total}
                    >
                        <PriceOverrideDatatable
                            data={nonTissue}
                            tableType={'pricingOverride'}
                            handleSetItemClick={handleSetItemClick}
                            ordersList={ordersList}
                            rowExpand={nonTissueRowExpand}
                            tableName={'nonTissue'}
                            isBundleTable={checkNonTissueBundle}
                            keyValue={'cfn'}
                            bundleSubGroup={'bundleItems'}
                            updateRowExpandHandler={updateRowExpandHandler}
                            isEquity={
                                orderType
                                    ? orderType === 'ZOR'
                                        ? true
                                        : false
                                    : false
                            }
                            isConsignment={
                                orderType
                                    ? orderType === 'KE'
                                        ? true
                                        : false
                                    : false
                            }
                            // isOrderType={}
                        />
                    </PriceOverrideContainer>
                </>
            ) : null}

            {tissue && tissue?.length > 0 ? (
                <>
                    <PriceOverrideContainer
                        title={t('consignment.productType.type.tissue')}
                        price={totalTissuePrice}
                        total={total}
                    >
                        <PriceOverrideDatatable
                            data={tissue}
                            tableType={'pricingOverride'}
                            handleSetItemClick={handleSetItemClick}
                            ordersList={ordersList}
                            rowExpand={tissueRowExpand}
                            tableName={'tissue'}
                            isBundleTable={checkTissueBundle}
                            keyValue={'cfn'}
                            bundleSubGroup={'bundleItems'}
                            updateRowExpandHandler={updateRowExpandHandler}
                        />
                    </PriceOverrideContainer>
                </>
            ) : null}
            {nonBilledList && nonBilledList?.length > 0 ? (
                <PriceOverrideContainer
                    title={t('reportUsage.summary.notBilled')}
                    price={0}
                    isNotBilled={true}
                >
                    <NonBilledDataTable
                        notBilledList={nonBilledList}
                        handleSetItemClick={handleSetItemClick}
                        ordersList={ordersList}
                    />
                </PriceOverrideContainer>
            ) : null}
        </>
    );
};

export default PriceOverrideDetailsListView;
